// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var container = "DateInput-module--container--1933e";
export var day = "DateInput-module--day--f86b3";
export var emphasis = "DateInput-module--emphasis--c36a7";
export var green = "#57d33b";
export var greenLink = "DateInput-module--green-link--55ea0";
export var grey = "var(--tone-mid)";
export var hideDays = "DateInput-module--hideDays--638df";
export var input = "DateInput-module--input--4a90a";
export var inputWrapper = "DateInput-module--inputWrapper--25eb9";
export var label = "DateInput-module--label--6a792";
export var month = "DateInput-module--month--d26fb";
export var notchGap = "32px";
export var orange = "#f8662b";
export var red = "#ff2741";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var year = "DateInput-module--year--dfcbd";
export var yellow = "#ffb100";